// @flow
import { themeStyle } from '../colorPalettes'

import { lightTheme } from './lightTheme'
import { darkTheme } from './darkTheme'

import type { ThemeType } from '..'

const streamnxtThemeName = 'streamnxt'

export const themeStreamnxt: ThemeType = {
  name: streamnxtThemeName,
  getThemeVariation: (themeVariation: string) => {
    switch (themeVariation) {
      case themeStyle.light:
        return lightTheme
      case themeStyle.dark:
        return darkTheme
      default:
        return darkTheme
    }
  },
}
